import { BaseUrlParamsFilter, BaseUrlParamsFilterProps } from '../../filters/base-url-params-filter';
import { OkvedPickerFieldFilter } from '../okved-picker/okved-picker-filter';

export const OkvedParamFilter = ({
  queryParamName,
  label,
  size = 'medium',
  customSize,
  ...otherProps
}: BaseUrlParamsFilterProps & { multi?: boolean; customSize?: number }) => {
  return (
    <BaseUrlParamsFilter queryParamName={queryParamName}>
      <OkvedPickerFieldFilter 
        name={queryParamName}
        label='ОКВЭД'
        customSize={customSize}
        size={size}
        {...otherProps}
      />
    </BaseUrlParamsFilter>
  );
};
